<template>
    <BasePage :loading="loading" :error="error" :params="params" style="overflow: hidden">
        <SotHeader label="Оплата обучения" />
        <div class="q-pa-md base-page-content" style="padding-top: 35px">
            <div v-show="!loading" class="column q-gutter-y-sm" style="margin-bottom: 10px; padding-top: 20px">
                <div v-show="user" class="text-center text-subtitle1" style="padding-bottom: 20px">Проверьте актуальность Ваших данных</div>
                <TextInput label="Фамилия*" v-model="surname" />
                <TextInput label="Имя*" v-model="name" />
                <TextInput label="Отчество (при наличии)" v-model="patrname" />
                <PhoneInput label="Контактный телефон*" v-model="tel" icon="" />
                <TextInput label="Почта*" v-model="email" />
                <div class="row no-wrap q-gutter-x-sm" style="padding: 20px 0 20px 0">
                    <q-checkbox v-model="accepted" />
                    <div class="cursor-pointer" @click="accepted = !accepted">
                        Принимаю условия <span class="cursor-pointer text-blue" @click.stop="openUrl('')">Политики</span>
                        обработки персональных данных и <span class="cursor-pointer text-blue" @click.stop="openUrl('')">договора оферты</span>
                    </div>
                </div>
                <!--<iframe width="558" height="315" src="//video.platformcraft.ru/embed/6295d800ef3db538190982ad" frameBorder="0" scrolling="no" allowFullScreen></iframe>-->
                <DefaultButton label="Оплатить" @click="pay" />
            </div>
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
import SotHeader from 'components/ui/design/SotHeader';
import DefaultButton from 'components/ui/common/DefaultButton';
import TextInput from 'components/ui/common/TextInput';
import PhoneInput from 'components/ui/PhoneInput';

export default {
    name: 'PagePayForCourse',
    components: {
        PhoneInput,
        TextInput,
        DefaultButton,
        SotHeader,
        BasePage,
    },
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    data () {
        return {
            loading: false,
            saving: false,
            error: undefined,
            accepted: false,
            surname: undefined,
            name: undefined,
            patrname: undefined,
            tel: undefined,
            email: undefined,
        };
    },
    computed: {
        user () {
            return this.$store.state.pages.user;
        },
        courseId () {
            return this.params.course_id;
        },
    },
    watch: {
        user () {
            this.$nextTick(() => {
                this.load();
            });
        },
    },
    mounted () {
        this.load();
    },
    methods: {
        load () {
            const { user } = this;
            if (user) {
                this.tel = user.tel;
                this.email = user.email;
                [this.surname, this.name, this.patrname] = user.shownname.split(' ');
            }
        },
        openUrl (url) {
            window.open(url, '_blank');
        },
        validate () {
            if (!this.surname) {
                this.$q.notify('Заполните обязательное поле: фамилия');
                return false;
            }
            if (!this.name) {
                this.$q.notify('Заполните обязательное поле: имя ');
                return false;
            }
            if (!this.tel) {
                this.$q.notify('Заполните обязательное поле: номер телефона');
                return false;
            }
            if (!this.email) {
                this.$q.notify('Заполните обязательное поле: электронный адрес');
                return false;
            }
            if (!this.accepted) {
                this.$q.notify('Для продолжения необходимо принять условия Политики обработки персональных данных и договора оферты');
                return false;
            }
            return true;
        },
        pay () {
            if (!this.validate()) {
                return;
            }
            console.log('pay');
        },
    },
};
</script>

<style scoped>

</style>
